/* eslint-disable no-undef */
import React, { useState, useMemo, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import useUserData from "../../hooks/useUserData";
import { useLocation, useNavigate } from "react-router-dom";
import ModalLogin from "../../components/Modal/Login/Login";
import { NAVIGATION } from "../../constants/Perfil/navigation";
import useAuthGuard from "../../hooks/useAuthGuard";
import DemoPageContent from "./DemoPageContent";
import PerfilLayout from "./PerfilLayout";

const Perfil = ({ window }) => {
  const { user, loadingUser, errorUser } = useUserData();
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const { openLoginModal, setOpenLoginModal, onSuccessLogin, isAuthenticated, logout} = useAuthGuard();

  const handleCloseLoginModal = () => {
    setOpenLoginModal(false);
  };

  const [activeSegment, setActiveSegment] = useState(
    pathname === "/perfil/devolve" ? "devolve" : "perfil"
  );

  useEffect(() => {
    setActiveSegment(pathname === "/perfil/devolve" ? "devolve" : "perfil");
  }, [pathname]);

  const session = useMemo(() => {
    if (!loadingUser && user) {
      return {
        user: {
          name: user.name,
          email: user.email,
          image: user.google_image || null,
          fallback: user.name ? user.name[0].toUpperCase() : "U",
        },
      };
    }
    return null;
  }, [loadingUser, user]);

  const signOut = useCallback(() => {
    logout();
    navigate("");
  }, [logout, navigate]);

  const authentication = useMemo(() => ({ signOut }), [signOut]);

  const handleNavigation = useCallback(
    (pathOrSegment) => {
      let segment = pathOrSegment;
      if (typeof segment === "string") {
        segment = segment.replace("/perfil/", "").replace("/", "");
      }
      switch (segment) {
        case "perfil":
          navigate("/perfil");
          setActiveSegment("perfil");
          break;
        case "devolve":
          navigate("/perfil/devolve");
          setActiveSegment("devolve");
          break;
        default:
          navigate("/perfil");
          setActiveSegment("perfil");
      }
    },
    [navigate]
  );

  const router = useMemo(
    () => ({
      pathname,
      searchParams: new URLSearchParams(),
      navigate: handleNavigation,
    }),
    [pathname, handleNavigation]
  );

  const navigationWithHandlers = useMemo(
    () =>
      NAVIGATION.map((item) => ({
        ...item,
        onClick: () => {
          handleNavigation(item.segment);
        },
      })),
    [handleNavigation]
  );

  return (
    <PerfilLayout 
      user={isAuthenticated ? user : null}
      onSignOut={() => {
        logout();              
        setOpenLoginModal(true); 
      }}
      menuItems={navigationWithHandlers}
    >
      <Box sx={{ minHeight: "100vh" }}>
        <DemoPageContent
          pathname={pathname}
          user={user}
          loadingUser={loadingUser}
          errorUser={errorUser}
        />

        <ModalLogin
          open={openLoginModal}
          handleClose={handleCloseLoginModal}
          onSuccess={onSuccessLogin}
          disableClose={!isAuthenticated}
        />
      </Box>
    </PerfilLayout>
  );
};
Perfil.propTypes = { window: PropTypes.func };

export default Perfil;

/* eslint-disable no-undef */

